import { render, staticRenderFns } from "./CoursewareReview.vue?vue&type=template&id=fe20adaa"
import script from "./CoursewareReview.vue?vue&type=script&lang=js"
export * from "./CoursewareReview.vue?vue&type=script&lang=js"
import style0 from "./CoursewareReview.vue?vue&type=style&index=0&id=fe20adaa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports